import { axiosInstance } from '../clients/axiosClient';
import { API_V1_PREFIX, isProd } from '../utils/constants';
import axios from 'axios';

export const createCheckoutSession = async (userId: string) => {
  try {
    const { data } = await axiosInstance.post(
      `${API_V1_PREFIX}/subscriptions`,
      {
        userId
      }
    );
    return data;
  } catch (error: any) {
    throw new Error(error);
  }
};

export interface StripeProduct {
  key: string;
  name: string;
  monthly_amount: number | null;
  yearly_amount: number | null;
  stripe_price_monthly_id: string;
  stripe_price_yearly_id: string;
  active: boolean;
  plan_type?: string;
  number_of_blood_test_plan?: number | null;
}

export interface StripeProductsResponse {
  products: StripeProduct[];
}

export const getStripeProducts = async (): Promise<StripeProductsResponse> => {
  try {
    const baseURL = isProd
      ? process.env.REACT_APP_API_BASE_URL_PROD
      : process.env.REACT_APP_API_BASE_URL_DEV;
    
    const { data } = await axios.get(
      `${baseURL}/${API_V1_PREFIX}subscriptions/stripe-products`
    );
    return data;
  } catch (error: any) {
    throw new Error(
      error?.response?.data?.message || 
      error?.response?.data?.detail || 
      error?.message || 
      'Failed to fetch products'
    );
  }
};

export interface FailedSubscriptionPaymentItem {
  member_id?: string | null;
  member_unique_id?: string | null;
  member_first_name?: string | null;
  member_last_name?: string | null;
  member_email?: string | null;
  customer_name?: string | null;
  customer_email?: string | null;
  subscription_status?: string | null;
  invoice_id: string;
  invoice_status?: string | null;
  amount_due_minor?: number | null;
  amount_due?: number | null;
  currency: string;
  attempt_count: number;
  failed_at?: string | null;
  next_payment_attempt?: string | null;
  failure_reason: string;
  failure_code?: string | null;
  decline_code?: string | null;
  failure_message?: string | null;
  update_payment_link?: string | null;
}

export interface ListFailedSubscriptionPaymentsResponse {
  items: FailedSubscriptionPaymentItem[];
  total_count: number;
}

export const getFailedSubscriptionPayments = async (
  limit: number,
  offset: number
): Promise<ListFailedSubscriptionPaymentsResponse> => {
  const { data } = await axiosInstance.get(
    `${API_V1_PREFIX}subscriptions/failed-payments`,
    { params: { limit, offset } }
  );
  return data;
};
